import { init as sentryCapacitorInit } from '@sentry/capacitor';
import { browserTracingIntegration, replayIntegration, init as sentryVueInit } from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  const { public: { sentry } } = useRuntimeConfig();
  
  if (!sentry.dsn) {
    return;
  }

  sentryCapacitorInit({
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: sentry.environment,
    integrations: [
      browserTracingIntegration({ router }),
      replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],

    beforeSend(event) {
      const isNetworkTypeError = event.exception?.values?.every(
        e => e.type === 'TypeError' && !(e.stacktrace?.frames ?? []).some(f => f.in_app)
      );

      if (isNetworkTypeError) {
        return null;
      }

      // DNS resolution failures (no/poor connectivity on the device) are common,
      // not actionable, and flood Sentry - only keep a third of them.
      const message = event.exception?.values?.[0]?.value ?? '';

      if (message.includes('Unable to resolve host') && message.includes('No address associated with hostname')) {
        return Math.random() < 1 / 3 ? event : null;
      }

      return event;
    },

    ignoreErrors: [
      /scan canceled/i
    ],
    tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE ? Number(process.env.SENTRY_TRACES_SAMPLE_RATE) : 0.2, // Performance monitoring, represents the percentage chance that any given transaction will be sent to Sentry.
    replaysSessionSampleRate: process.env.SENTRY_REPLAY_SAMPLE_RATE ? Number(process.env.SENTRY_REPLAY_SAMPLE_RATE) : 0,
    replaysOnErrorSampleRate: process.env.SENTRY_ERROR_REPLAY_SAMPLE ? Number(process.env.SENTRY_ERROR_REPLAY_SAMPLE) : 0
  }, sentryVueInit);
});